import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const Corporate = ({ triggerDemo, demoMode }: DemoSectionProps ) => {
  const demos = [
    {
      demo: `corporate${demoMode}Demo`,
      isReset: false,
      buttonText: 'Corporate Demo',
      features: [
        'Run all corporate demo scripts'
      ]
    },
    {
      demo: 'waterlineDemo',
      isReset: false,
      buttonText: 'Waterline Demo',
      features: [
        'Waterline Demo'
      ]
    },
    {
      demo: 'resetAllWaterline',
      isReset: true,
      buttonText: 'Reset Waterline data for all children',
      features: [
        'Remove all Waterline data'
      ]
    },
    {
      demo: `corporate${demoMode}UpdateInformation`,
      isReset: false,
      buttonText: 'Update Children Info',
      features: [
        'Update all names, phones, addresses'
      ]
    },
    {
      demo: 'medsDemoScenario',
      isReset: false,
      buttonText: 'Meds Demo Scenario',
      features: [
        'Apply a predefined meds scenario for demo purpose'
      ]
    },
    {
      demo: 'kitsOnApproval',
      isReset: false,
      buttonText: 'Kits On Approval',
      features: [
        'At least 5 practices in corporate with kits on approval having up-to-date, expiring and expired status'
      ]
    },
    {
      demo: 'resetMedicationsForAllChildren',
      isReset: true,
      buttonText: 'Reset Medications for all children',
      features: [
        'Remove all Medications data'
      ]
    },
    {
      demo: 'devicesDemoScenario',
      isReset: false,
      buttonText: 'Devices Demo Scenario',
      features: [
        'Apply a predefined Devices scenario for demo purpose'
      ]
    },
    {
      demo: 'resetDevicesForAllChildren',
      isReset: true,
      buttonText: 'Reset Devices for all Children',
      features: [
        'Remove all Devices data'
      ]
    },
    {
      demo: 'bioDemoScenario',
      isReset: false,
      buttonText: 'Bio Demo Scenario',
      features: [
        'Apply a predefined Biological scenario for demo purpose'
      ]
    },
    {
      demo: 'resetBioForAllChildren',
      isReset: true,
      buttonText: 'Reset Bio for all children',
      features: [
        'Remove all Biological data'
      ]
    },
    {
      demo: 'medicalWasteDemoScenario',
      isReset: false,
      buttonText: 'Medical Waste Demo Scenario',
      features: [
        'Apply a predefined Medical Waste (sharps) scenario for demo purpose'
      ]
    },
    {
      demo: 'resetMedicalWasteForAllChildren',
      isReset: true,
      buttonText: 'Reset Medical Waste for all children',
      features: [
        'Remove all Medical Waste data'
      ]
    },
    {
      demo: 'amalgamDemoScenario',
      isReset: false,
      buttonText: 'Amalgam Demo Scenario',
      features: [
        'Apply a predefined Amalgam scenario for demo purpose'
      ]
    },
    {
      demo: 'resetAmalgamForAllChildren',
      isReset: true,
      buttonText: 'Reset Amalgam for all children',
      features: [
        'Remove all Amalgam data'
      ]
    },
    {
      demo: 'unusedMedicationsDemoScenario',
      isReset: false,
      buttonText: 'Unused Medications Demo Scenario',
      features: [
        'Apply a predefined Unused Medications scenario for demo purpose'
      ]
    },
    {
      demo: 'resetUnusedMedicationsForAllChildren',
      isReset: true,
      buttonText: 'Reset Unused Medications for all children',
      features: [
        'Remove all Unused Medications data'
      ]
    },
    {
      demo: 'practiceOshaHipaaTraining',
      isReset: false,
      buttonText: 'OSHA/HIPAA Compliance Demo',
      features: []
    }
  ]

  return (
    <DemoCard headerText='Corporate Mode' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default Corporate